//Jquery Start
(function($) { 
	// Mobile toogle menu
	$('.mobilelistnav .mob_submenu').after('<div class="sub_menu_btn burslines_menu"><span class="line"></span><span class="line"></span></div>');
	$('.sub_menu_btn').on('click', function(){
		$(this).toggleClass('close_sub_menu');
		$(this).prev('ul').stop().slideToggle();
		$(this).parent().toggleClass('openlist');
	});
	//Target Window Open
	$('.open_target').on('click', function(){
		$($(this).data('target')).fadeIn().addClass('show');
		$(this).addClass('show');
		return false;
	})
	$('.close_target').on('click', function(){
		$($(this).data('target')).removeClass('show').fadeOut();
		$('.open_target, .mobilebtn').removeClass('show');
		$('body').removeClass('scroll-hidden');
		return false;
	})
	$('.mobilebtn').on('click', function(){
		if($(this).hasClass('show')){
			$($(this).data('target')).removeClass('show').fadeOut()
			$(this).removeClass('show');
			$('body').removeClass('scroll-hidden');
		}else{
			$($(this).data('target')).fadeIn().addClass('show');
			$(this).addClass('show');
			$('body').addClass('scroll-hidden');
		}
		return false;
	});
	//opening sub menu
	$('.mobilelistnav li a').each(function(){
		if($(this).attr('href') == '/collections/all-products'){
			$(this).parent().addClass('openlist')
			$(this).parents('.mob_submenu').slideDown()
			$(this).next('.mob_submenu').slideDown()
			$(this).siblings('.burslines_menu').addClass('close_sub_menu');
		}
	})

    
    //Sticky head
	// navbar fixed scrolling
    $(window).on("scroll",function () {
		let bodyScroll =  $(window).scrollTop();
		let	navbar = $(".header-sticky");
		if(bodyScroll > 5){
			navbar.addClass("header_appear");
		}else{
			navbar.removeClass("header_appear");
		}
	});
	//nav menu hover add class parrent
	$('.header.nav-megamenu .menu-list>li').hover(function(){
		if($(this).children().hasClass('dropdown-wrapper')){
			$('.header-sticky').addClass('hovered')
		}
	}, function(){
		$('.header-sticky').removeClass('hovered')
	});
	//header counter custom update
	$(".add-to-cart-button").click(function(){
		setTimeout(function() {
			jQuery.getJSON('/cart/update.js', function(cart) {
				if(cart.item_count > 0) {
					$("span.cart-counter").removeClass('hidden');
					$("span.cart-counter").html(cart.item_count);
				}
			});
		}, 3000);
	 });
	 //Header search toogle window
	 $('.head-search-btns svg.icon').on('click', function(){
		if($(this).hasClass('modal__toggle-open')){
			$('details-modal.header__search').addClass('show');
			$(this).addClass('hidden')
		}else{
			$('details-modal.header__search').removeClass('show');
			$('.modal__toggle-open').removeClass('hidden')
		}
	 });
	 //Footer mobile menu toggle
	 $('.mobile-toogle-menu .foot-menu-title').on('click', function(){
		if(!$(this).hasClass('active')){
			$(this).next().stop().slideDown();
			$(this).addClass('active')
		}else{
			$(this).removeClass('active')
			$(this).next().stop().slideUp();
		}
	 });
  
	//Scroll Animation
	$(window).on('scroll', max_scrollanimation);
	function max_scrollanimation() {
		var win_height_padded = $(window).height() * 1.1;
		var scrolled = $(window).scrollTop();
		$(".scrollanimation:not(.animated)").each(function () {
		   var $this     = $(this),
			   offsetTop = $this.offset().top;

		   if (scrolled + win_height_padded > offsetTop) {

				 if ($this.data('timeout')) {
				   window.setTimeout(function(){
					 $this.addClass('animated ' + $this.data('animation'));
				   }, parseInt($this.data('timeout'),10));
				 } else {
				   $this.addClass('animated ' + $this.data('animation'));
				 }

			}

		});
	}



        if (document.querySelectorAll('#pbSwiper').length > 0) {
          let mySwiper;
          // alert("inside");
            mySwiper = new Swiper('#pbSwiper', {
              slidesPerView: 3,
              spaceBetween: 24,
              freeMode: false,
              navigation: {
                nextEl: ".slider-nav-next",
                prevEl: ".slider-nav-prev",
              },
              breakpoints: {
                0: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                450: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                767: {
                  slidesPerView: 2,
                  spaceBetween: 24,
                },
                991: {
                  slidesPerView: 2,
                  spaceBetween: 24,
                },
                1000: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                }
              }
            });

        }
   if (document.querySelectorAll('#rev-id').length > 0){
     
      $("#rev-id").slick({
       slidesToShow: 3,
       infinite:false,
       slidesToScroll: 1,
       autoplay: false,
       autoplaySpeed: 2000,
        dots: false,
        responsive:[
          {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            }
          },
          {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            }
          },
          {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            }
          },
        ]
      });
   }

  // var WINWDTH = $(window).width();
  // if(WINWDTH < 800){
  //    setTimeout(function() { 
  //        var FHTML = $('#frequntlyVis').html();
  //       console.log(FHTML);
       
  //       $('#frequntlyVis').hide();
  //       $("#frequentlyMob").html(FHTML);
  //   }, 5000);
  // }

})(jQuery); //END jQuery

